import fetch from '../fetch';
import { fulfillmentErrorMessages } from './errors';
import pollEntitlementsUntilComplete from '../../helpers/pollEntitlementsUntilComplete';
import { trackSwitchEntitlementsPollRetry, trackSwitchEntitlementsPollTimeout } from '../../helpers/switch/analytics';
import { channels } from '../../constants';
import { ENTITLEMENTS_PLAN } from '../../constants/endpoints';

export const FULFILL_FLEX_DOWNSELL_SUBSCRIPTION = 'FULFILL_FLEX_DOWNSELL_SUBSCRIPTION';
export const FLEX_DOWNSELL_SUBSCRIPTION_FULFILLED = 'FLEX_DOWNSELL_SUBSCRIPTION_FULFILLED';
export const FLEX_DOWNSELL_FULFILLMENT_FAILED = 'FLEX_DOWNSELL_FULFILLMENT_FAILED';
export const MIGRATION_BLOCKED_ERROR_INFO = 'MigrationBlocked';

const getFulfillmentError = errorMessageKey =>
  new Error(JSON.stringify(fulfillmentErrorMessages[errorMessageKey] || fulfillmentErrorMessages.default));

const isValidOfferId = offerId =>
  (typeof offerId === 'string' && offerId.length > 0) || (typeof offerId === 'number' && Number.isFinite(offerId));

const defaultChannel = channels.online;

const getErrorInfo = async error => {
  if (error?.errorResponse?.ErrorInfo) {
    return error.errorResponse.ErrorInfo;
  }

  if (typeof error?.json === 'function') {
    try {
      const errorBody = await error.json();
      return errorBody?.errorResponse?.ErrorInfo;
    } catch {
      return undefined;
    }
  }

  return undefined;
};

export default function fulfillFlexDownsell(offerId, channel = defaultChannel, errorMessageKey = undefined) {
  return async dispatch => {
    if (!isValidOfferId(offerId)) {
      const action = {
        type: FLEX_DOWNSELL_FULFILLMENT_FAILED,
        error: true,
        payload: getFulfillmentError(errorMessageKey),
      };

      dispatch(action);
      return action;
    }

    dispatch({ type: FULFILL_FLEX_DOWNSELL_SUBSCRIPTION, meta: { clearErrors: true } });

    try {
      await dispatch(
        fetch(ENTITLEMENTS_PLAN, {
          method: 'PUT',
          body: {
            channel,
            planCode: offerId,
          },
        })
      );

      const completed = await pollEntitlementsUntilComplete({
        dispatch,
        fetchAction: fetch,
        onRetryError: ({ attempts }) => {
          trackSwitchEntitlementsPollRetry(attempts);
        },
        onTimeout: ({ attempts, elapsedMs }) => {
          trackSwitchEntitlementsPollTimeout(attempts, elapsedMs);
        },
      });

      if (completed) {
        const action = {
          type: FLEX_DOWNSELL_SUBSCRIPTION_FULFILLED,
          payload: { success: true },
        };

        dispatch(action);
        return action;
      }

      // If polling times out, continue as success and allow completion flow to proceed.
      const timeoutAction = {
        type: FLEX_DOWNSELL_SUBSCRIPTION_FULFILLED,
        payload: { success: true },
      };

      dispatch(timeoutAction);
      return timeoutAction;
    } catch (error) {
      const errorInfo = await getErrorInfo(error);
      const action = {
        type: FLEX_DOWNSELL_FULFILLMENT_FAILED,
        error: true,
        payload: getFulfillmentError(errorMessageKey),
        ...(errorInfo ? { meta: { errorInfo } } : {}),
      };

      dispatch(action);
      return action;
    }
  };
}
